if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    var variant = data && data.variant;
    var html = data && data.html;
    if (!variant || !variant.id) return;

    // Toggle custom SKU lines
    var id = String(variant.id);
    document.querySelectorAll('.pp_sku__js').forEach(function (el) {
      el.style.display = el.getAttribute('data-id') === id ? '' : 'none';
    });
    
    try {
      if (!html) return;

      var newWrapper = html.querySelector('.product__media-wrapper');
      var currentWrapper = document.querySelector('.product__media-wrapper');
      if (!newWrapper || !currentWrapper) return;

      currentWrapper.replaceWith(newWrapper);
    } catch (e) {
      console && console.warn && console.warn('Variant metafield gallery sync failed', e);
    }
  });
}